// TrialBadge — shows days remaining, turns red at ≤2 days, "PRO ACTIVO" if PRO.
import React from "react";
import { Crown, Clock } from "lucide-react";
import { tLm } from "../../i18n/liqmap";
import { useLanguage } from "../../i18n/LanguageContext";

export default function TrialBadge({ status }) {
  const { lang } = useLanguage();
  const t = tLm(lang).trial;
  if (!status) return null;
  if (status.is_pro) {
    return (
      <div
        className="inline-flex items-center gap-1.5 rounded-full border border-[#f97316]/40 bg-[#f97316]/[0.12] px-3 py-1.5 font-mono text-[10px] font-black tracking-[0.18em]"
        style={{ color: "#f97316" }}
        data-testid="liqmap-trial-badge"
      >
        <Crown className="h-3 w-3" />
        {t.pro_active}
      </div>
    );
  }
  const n = status.days_remaining ?? 0;
  const label = n === 1 ? t.days_left_one : t.days_left_many.replace("{n}", n);
  const isLow = n <= 2;
  return (
    <div
      className="inline-flex items-center gap-1.5 rounded-full border border-[#a855f7]/40 bg-[#a855f7]/[0.12] px-3 py-1.5 font-mono text-[10px] font-black tracking-[0.18em] text-white"
      data-testid="liqmap-trial-badge"
    >
      <Clock className="h-3 w-3 text-[#a855f7]" />
      <span
        className="rounded-full px-2 py-0.5 text-[9px]"
        style={{ background: isLow ? "#ff3b5c" : "#a855f7", color: "white" }}
      >
        {label}
      </span>
    </div>
  );
}
